import aliexpressIcon from "../assets/integration-icons/aliexpress.svg";
import attribulyIcon from "../assets/integration-icons/admin/attribuly-com.png";
import omnisendIcon from "../assets/integration-icons/admin/omnisend-com.png";
import trustwillIcon from "../assets/integration-icons/admin/loloyal-com.png";
import similarwebIcon from "../assets/integration-icons/admin/similarweb-com.png";
import bigCommerceIcon from "../assets/integration-icons/bigcommerce.svg";
import discordIcon from "../assets/integration-icons/discord.svg";
import dingtalkIcon from "../assets/integration-icons/dingtalk.svg";
import facebookIcon from "../assets/integration-icons/facebook.svg";
import figmaIcon from "../assets/integration-icons/figma.svg";
import feishuIcon from "../assets/integration-icons/feishu.svg";
import googleAdsIcon from "../assets/integration-icons/google-ads.png";
import googleAnalyticsIcon from "../assets/integration-icons/google-analytics.png";
import googleIcon from "../assets/integration-icons/google.svg";
import goAffProIcon from "../assets/integration-icons/goaffpro.svg";
import hubspotIcon from "../assets/integration-icons/hubspot.svg";
import instagramIcon from "../assets/integration-icons/instagram.svg";
import judgeMeIcon from "../assets/integration-icons/judge-me.svg";
import klaviyoIcon from "../assets/integration-icons/klaviyo.png";
import linkedInAdsIcon from "../assets/integration-icons/linkedin-ads.png";
import looxIcon from "../assets/integration-icons/loox.svg";
import magentoIcon from "../assets/integration-icons/magento.svg";
import mailchimpIcon from "../assets/integration-icons/mailchimp.svg";
import metaAdsIcon from "../assets/integration-icons/meta-ads.png";
import noxInfluencerIcon from "../assets/integration-icons/noxinfluencer.svg";
import pinterestIcon from "../assets/integration-icons/pinterest.svg";
import prestashopIcon from "../assets/integration-icons/prestashop.png";
import redditIcon from "../assets/integration-icons/reddit.svg";
import semrushIcon from "../assets/integration-icons/semrush.svg";
import shipStationIcon from "../assets/integration-icons/shipstation.svg";
import shopifyIcon from "../assets/integration-icons/shopify.svg";
import slackIcon from "../assets/integration-icons/slack.svg";
import stripeIcon from "../assets/integration-icons/stripe.svg";
import tiktokIcon from "../assets/integration-icons/tiktok.svg";
import wixIcon from "../assets/integration-icons/wix.png";
import woocommerceIcon from "../assets/integration-icons/woocommerce.svg";
import upPromoteIcon from "../assets/integration-icons/uppromote.svg";
import xIcon from "../assets/integration-icons/x.svg";
import ahrefsIcon from "../assets/integration-icons/ahrefs.svg";
import youtubeIcon from "../assets/integration-icons/youtube.svg";
import zendeskIcon from "../assets/integration-icons/zendesk.svg";

export type IntegrationBrandIcon = {
  name: string;
  src: string | null;
};

const INTEGRATION_BRAND_ICON_BY_KEY: Record<string, IntegrationBrandIcon> = {
  shopify: { name: "Shopify", src: shopifyIcon },
  woocommerce: { name: "WooCommerce", src: woocommerceIcon },
  bigcommerce: { name: "BigCommerce", src: bigCommerceIcon },
  magento: { name: "Magento", src: magentoIcon },
  "adobe-commerce": { name: "Adobe Commerce", src: magentoIcon },
  prestashop: { name: "PrestaShop", src: prestashopIcon },
  "presta-shop": { name: "PrestaShop", src: prestashopIcon },
  wix: { name: "Wix", src: wixIcon },
  aliexpress: { name: "AliExpress", src: aliexpressIcon },
  "google-ads": { name: "Google Ads", src: googleAdsIcon },
  googleads: { name: "Google Ads", src: googleAdsIcon },
  "google-analytics": { name: "Google Analytics", src: googleAnalyticsIcon },
  "google-analytics-4": {
    name: "Google Analytics 4",
    src: googleAnalyticsIcon,
  },
  ga4: { name: "Google Analytics 4", src: googleAnalyticsIcon },
  klaviyo: { name: "Klaviyo", src: klaviyoIcon },
  "tiktok-ads": { name: "TikTok Ads", src: tiktokIcon },
  tiktokads: { name: "TikTok Ads", src: tiktokIcon },
  "tiktok-shop": { name: "TikTok Shop", src: tiktokIcon },

  "google-search-console": { name: "Google Search Console", src: googleIcon },
  "google-merchant-center": { name: "Google Merchant Center", src: googleIcon },
  "google-workspace": { name: "Google Workspace", src: googleIcon },
  "meta-ads": { name: "Meta Ads", src: metaAdsIcon },
  metaads: { name: "Meta Ads", src: metaAdsIcon },
  "facebook-ads": { name: "Meta Ads", src: metaAdsIcon },
  "facebook-page": { name: "Facebook Page", src: facebookIcon },
  instagram: { name: "Instagram", src: instagramIcon },
  semrush: { name: "Semrush", src: semrushIcon },
  similarweb: { name: "Similarweb", src: similarwebIcon },
  ahrefs: { name: "Ahrefs", src: ahrefsIcon },
  mailchimp: { name: "Mailchimp", src: mailchimpIcon },
  omnisend: { name: "Omnisend", src: omnisendIcon },
  trustwill: { name: "TrustWILL", src: trustwillIcon },
  "trustwill-loyalty": { name: "TrustWILL", src: trustwillIcon },
  loloyal: { name: "TrustWILL", src: trustwillIcon },
  "judge-me": { name: "Judge.me", src: judgeMeIcon },
  "judge.me": { name: "Judge.me", src: judgeMeIcon },
  "linkedin-ads": { name: "LinkedIn Ads", src: linkedInAdsIcon },
  linkedinads: { name: "LinkedIn Ads", src: linkedInAdsIcon },
  "pinterest-ads": { name: "Pinterest Ads", src: pinterestIcon },
  pinterestads: { name: "Pinterest Ads", src: pinterestIcon },
  "x-ads": { name: "X Ads", src: xIcon },
  x: { name: "X", src: xIcon },
  "twitter-ads": { name: "X Ads", src: xIcon },
  twitter: { name: "X", src: xIcon },
  youtube: { name: "YouTube", src: youtubeIcon },
  "youtube-ads": { name: "YouTube", src: youtubeIcon },
  reddit: { name: "Reddit", src: redditIcon },
  attribuly: { name: "Attribuly", src: attribulyIcon },
  hubspot: { name: "HubSpot", src: hubspotIcon },
  zendesk: { name: "Zendesk", src: zendeskIcon },
  shipstation: { name: "ShipStation", src: shipStationIcon },
  stripe: { name: "Stripe", src: stripeIcon },
  loox: { name: "Loox", src: looxIcon },
  noxinfluencer: { name: "NoxInfluencer", src: noxInfluencerIcon },
  goaffpro: { name: "GoAffPro", src: goAffProIcon },
  uppromote: { name: "UpPromote", src: upPromoteIcon },
  supermetrics: { name: "Supermetrics", src: null },
  feishu: { name: "Feishu", src: feishuIcon },
  dingtalk: { name: "DingTalk", src: dingtalkIcon },
  figma: { name: "Figma", src: figmaIcon },
  "figma-oauth": { name: "Figma", src: figmaIcon },
  gamma: { name: "Gamma", src: null },
  slack: { name: "Slack", src: slackIcon },
  discord: { name: "Discord", src: discordIcon },
};

const INTEGRATION_ALIASES: Record<string, string> = {
  "google ads": "google-ads",
  "google analytics": "google-analytics",
  "google analytics 4": "google-analytics-4",
  "google search console": "google-search-console",
  "search console": "google-search-console",
  gsc: "google-search-console",
  "google merchant center": "google-merchant-center",
  "merchant center": "google-merchant-center",
  "google workspace": "google-workspace",
  workspace: "google-workspace",
  "tiktok ads": "tiktok-ads",
  "tiktok shop": "tiktok-shop",
  "meta ads": "meta-ads",
  "facebook ads": "meta-ads",
  "facebook page": "facebook-page",
  "figma oauth": "figma-oauth",
  "klaviyo-oauth": "klaviyo",
  "klaviyo oauth": "klaviyo",
  "linkedin ads": "linkedin-ads",
  linkedin: "linkedin-ads",
  "pinterest ads": "pinterest-ads",
  pinterest: "pinterest-ads",
  "presta shop": "prestashop",
  "presta-shop": "prestashop",
  "x ads": "x-ads",
  "twitter ads": "x-ads",
  "youtube ads": "youtube",
  "youtube-ads": "youtube",
  youtube: "youtube",
  "reddit social": "reddit",
  "reddit-social": "reddit",
  "attribuly attribution": "attribuly",
  "judge me": "judge-me",
};

function normalizeIntegrationKey(value: string): string {
  const normalized = value
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[\s_]+/g, "-");
  return INTEGRATION_ALIASES[value.trim().toLowerCase()] ?? normalized;
}

export function getIntegrationBrandIcon(name: string): IntegrationBrandIcon {
  const key = normalizeIntegrationKey(name);
  return (
    INTEGRATION_BRAND_ICON_BY_KEY[key] ?? {
      name,
      src: null,
    }
  );
}
